import ApiManager from '../api/api-manager';
import CONFIG from '../config/app-config';

async function getLocationName(lat, lon) {
  try {
    const data = await ApiManager.request(
      `${CONFIG.MAP_TILER_BASE_URL}/geocoding/${lon},${lat}.json?key=${CONFIG.MAP_TILER_KEY}`
    );
    if (data.features && data.features.length > 0) {
      const placeName = data.features[0].place_name;
      const parts = placeName.split(',');
      if (parts.length >= 2) return `${parts[0].trim()}, ${parts[1].trim()}`;
      return parts[0].trim();
    }
  } catch (_) {}
  return `${lat.toFixed(3)}, ${lon.toFixed(3)}`;
}

async function searchLocation(query) {
  return ApiManager.request(
    `${CONFIG.MAP_TILER_BASE_URL}/geocoding/${encodeURIComponent(query)}.json?key=${CONFIG.MAP_TILER_KEY}&limit=5`
  );
}

function getMapStyleUrl(isDark = false, layerType = 'streets') {
  switch (layerType) {
    case 'satellite':
      return `${CONFIG.MAP_TILER_BASE_URL}/maps/satellite/style.json?key=${CONFIG.MAP_TILER_KEY}`;
    case 'terrain':
      return `${CONFIG.MAP_TILER_BASE_URL}/maps/outdoor-v2/style.json?key=${CONFIG.MAP_TILER_KEY}`;
    default:
      return isDark
        ? `${CONFIG.MAP_TILER_BASE_URL}/maps/streets-v2-dark/style.json?key=${CONFIG.MAP_TILER_KEY}`
        : `${CONFIG.MAP_TILER_BASE_URL}/maps/streets-v2/style.json?key=${CONFIG.MAP_TILER_KEY}`;
  }
}

function buildMapConfig(container, isDark = false, layerType = 'streets') {
  return {
    container,
    style: getMapStyleUrl(isDark, layerType),
    center: [113.9213, -0.7893],
    zoom: 5,
  };
}

async function getUserLocation() {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      fallbackToIPLocation(resolve, reject);
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (pos) => resolve({ lat: pos.coords.latitude, lon: pos.coords.longitude }),
      () => fallbackToIPLocation(resolve, reject),
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 300000 }
    );
  });
}

async function fallbackToIPLocation(resolve, reject) {
  try {
    const mt = await ApiManager.request(
      `${CONFIG.MAP_TILER_BASE_URL}/geocoding.json?key=${CONFIG.MAP_TILER_KEY}`
    );
    if (mt && mt.features && mt.features[0]) {
      const [lon, lat] = mt.features[0].center;
      resolve({ lat, lon });
      return;
    }
  } catch (_) {}
  try {
    const data = await ApiManager.request(CONFIG.IP_LOCATION_URL);
    if (data.latitude && data.longitude) {
      resolve({ lat: data.latitude, lon: data.longitude });
      return;
    }
  } catch (err) {
    reject(err);
    return;
  }
  reject(new Error('All fallbacks failed'));
}

export { getLocationName, searchLocation, getMapStyleUrl, getUserLocation, buildMapConfig };
